import './App.css';
import Home from './components/Home';
import Content from "./components/Content"
import "./assets/index-3c583176.css"
import "./assets/style.css"

function App() {
  return (
    <div className="w-full h-auto min-h-screen">
      <Home/>
      <Content/>
    </div>
  );
}

export default App;
